// src/features/eventos/hooks/useFormActions.js
import { useCallback } from "react";

/**
 * Acciones reutilizables para mutar el "form" de AñadirEvento sin repetir lógica.
 * Mantiene el mismo patrón inmutable que ya estabas usando.
 */
export function useFormActions(setForm) {
    const setField = useCallback((name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
    }, [setForm]);

    const updateArray = useCallback((arrayName, index, field, value) => {
        setForm((prev) => {
            const arr = Array.isArray(prev[arrayName]) ? [...prev[arrayName]] : [];
            arr[index] = { ...(arr[index] || {}), [field]: value };
            return { ...prev, [arrayName]: arr };
        });
    }, [setForm]);

    const setArrayItem = useCallback((arrayName, index, nextItem) => {
        setForm((prev) => {
            const arr = Array.isArray(prev[arrayName]) ? [...prev[arrayName]] : [];
            arr[index] = nextItem;
            return { ...prev, [arrayName]: arr };
        });
    }, [setForm]);

    const addItem = useCallback((arrayName, defaultItem) => {
        setForm((prev) => {
            const arr = Array.isArray(prev[arrayName]) ? prev[arrayName] : [];
            return { ...prev, [arrayName]: [...arr, defaultItem] };
        });
    }, [setForm]);

    const removeItem = useCallback((arrayName, index) => {
        setForm((prev) => {
            const arr = Array.isArray(prev[arrayName]) ? [...prev[arrayName]] : [];
            arr.splice(index, 1);
            return { ...prev, [arrayName]: arr };
        });
    }, [setForm]);

    /**
     * Mueve un elemento dentro de un array (p.ej. participaciones) sin perder inmutabilidad.
     */
    const moveItem = useCallback((arrayName, fromIdx, toIdx) => {
        if (fromIdx === toIdx || fromIdx == null || toIdx == null) return;

        setForm((prev) => {
            const arr = Array.isArray(prev[arrayName]) ? [...prev[arrayName]] : [];
            if (fromIdx < 0 || fromIdx >= arr.length || toIdx < 0 || toIdx >= arr.length) return prev;

            const [moved] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, moved);
            return { ...prev, [arrayName]: arr };
        });
    }, [setForm]);

    return {
        setField,
        updateArray,
        setArrayItem,
        addItem,
        removeItem,
        moveItem,
    };
}
